import React, {useEffect} from "react";
import {NomenclatureTable} from "../../components/nomenclature/table/NomenclatureTable";
import {useAppSelector} from "../../hooks/useAppSelector";
import {useSearchNomenclatureGuidePageQuery} from "../../store/backend-api/backend.api";
import {useFiltersActions} from "../../hooks/useFiltersActions";
import {useFilterNodesActions} from "../../hooks/useMenuFiltersActions";
import {GuideTopBox} from "../../components/ui/table-components/GuideTopBox";
import {productionNomenclatureClassifierToString} from "../../data/NomenclatureData";
import {TableFilterKey} from "../../model/filters/TableFiltersDefinitions";
import {useDataActions} from "../../hooks/useDataActions";
import {DEFAULT_NOMENCLATURE_GUIDE_FILTER} from "../../model/filters/DefaultFilters";
import {MultiSelect} from "../../components/ui/form-components/standalone/MultiSelect";
import {OptionType} from "../../model/option-type/OptionType";
import {ProductionNomenclatureClassifier} from "../../model/nomenclature/NomenclatureForm";
import {tablePageStyle} from "../../utils/TailwindStyles";

export function NomenclatureGuide() {
    const {updateFilterAndClearData} = useFiltersActions()
    const {addFiltersToMenu} = useFilterNodesActions()
    const {addData} = useDataActions()

    const state = useAppSelector(state => state.sessionStorage.filters)
    const filter = state[TableFilterKey.NOMENCLATURE_GUIDE_FILTER].filter;

    const data = useAppSelector(state => state.data.data[TableFilterKey.NOMENCLATURE_GUIDE_FILTER])

    const {data: tablePage} = useSearchNomenclatureGuidePageQuery(filter)

    const selectOptions = Array.from(productionNomenclatureClassifierToString.keys()).map(key => ({
        label: productionNomenclatureClassifierToString.get(key)!,
        value: key
    }))

    useEffect(() => {
        addFiltersToMenu({
            key: TableFilterKey.NOMENCLATURE_GUIDE_FILTER,
            value: [{
                filterName: "Производственный классификатор",
                filter: <MultiSelect
                    options={selectOptions}
                    onChange={(options: readonly OptionType<ProductionNomenclatureClassifier>[] | null) => {
                        updateFilterAndClearData({
                            key: TableFilterKey.NOMENCLATURE_GUIDE_FILTER,
                            value: {
                                ...filter,
                                productionNomenclatureClassifier: options ? options.map(option => option.value) : []
                            }
                        })
                    }}
                    width={"270px"}
                    defaultOptions={filter.productionNomenclatureClassifier.map(value => ({
                        label: productionNomenclatureClassifierToString.get(value)!,
                        value: value
                    }))}
                />
            }]
        })
    }, [filter])

    useEffect(() => {
        if (tablePage) {
            if (!data || data.rows.length < (tablePage.pageNumber * DEFAULT_NOMENCLATURE_GUIDE_FILTER.pageSize) + 1) {
                addData({key: TableFilterKey.NOMENCLATURE_GUIDE_FILTER, data: tablePage})
            }
        }

    }, [tablePage]);

    return (
        <div className={tablePageStyle}>
            <GuideTopBox tableFilterKey={TableFilterKey.NOMENCLATURE_GUIDE_FILTER}
                         createNavigationURL={'/nomenclature/new'}
                         searchInfo={"Поиск по основному артикулу и наименованию."}/>
            {data && <NomenclatureTable data={data}/>}
        </div>
    )
}